/* Alura site-wide JS. This file ships empty with the theme as its slot for customer
   scripts and layout/theme.liquid loads it on every page. */

/* The privacy policy tells visitors they can change their cookie choice at any time.
   Shopify's banner exposes that as window.privacyBanner.showPreferences() but renders no
   control for it, so add one to the footer Legal list, next to the policy links.
   Guarded: if the banner bundle is absent or the list is not found, nothing is added. */
(function () {
  function addCookieLink() {
    if (!(window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function')) return;
    var privacy = document.querySelector('footer a[href="/policies/privacy-policy"], .wt-footer a[href="/policies/privacy-policy"]');
    if (!privacy) return;
    var item = privacy.closest('li');
    var list = item && item.parentElement;
    if (!list || list.querySelector('[data-alura-cookie-prefs]')) return;
    var li = item.cloneNode(false);
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.setAttribute('data-alura-cookie-prefs', '');
    btn.textContent = 'Cookie preferences';
    btn.className = privacy.className;
    btn.style.cssText = 'background:none;border:0;padding:0;margin:0;font:inherit;color:inherit;cursor:pointer;text-align:left;';
    btn.addEventListener('click', function () { window.privacyBanner.showPreferences(); });
    li.appendChild(btn);
    list.appendChild(li);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', addCookieLink);
  else addCookieLink();
})();

/* Huz (2 Oct): the serum word (Reverse / Revitalise / Repair) takes its box colour.
   Product cards do this in snippets/card.liquid; the product page H1 comes from a vendor
   snippet, so the word is wrapped here instead of forking it. Colour only - the text node
   is split in place, so nothing moves. Guarded: no title, no match, or already wrapped =
   nothing happens. Colours live in custom.css (.alura-serum--*). */
(function () {
  function colourSerumWord() {
    document.querySelectorAll('.wt-product__name').forEach(function (title) {
      if (title.querySelector('.alura-serum')) return;
      for (var i = 0; i < title.childNodes.length; i++) {
        var node = title.childNodes[i];
        if (node.nodeType !== 3) continue;
        var match = node.nodeValue.match(/\b(Reverse|Revitalise|Repair)\b/);
        if (!match) continue;
        var word = node.splitText(match.index);
        word.splitText(match[0].length);
        var span = document.createElement('span');
        span.className = 'alura-serum alura-serum--' + match[0].toLowerCase();
        span.textContent = match[0];
        title.replaceChild(span, word);
        return;
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', colourSerumWord);
  else colourSerumWord();
})();
